import Spacer from "@components/Spacer";
import Button from "@components/button";
import ClosableModal from "@components/closable-modal/closable-modal";
import ModalPadding from "@components/closable-modal/modal-padding";
import PlusIcon from "@components/icons/plus-icon";
import ModalTitle from "@components/modal-title";
import TextInput from "@components/text-input";
import * as React from "react";
import { useFormState } from "react-native-use-form";
import { useWishlistStore } from "@features/favourite/wishlist-store";
import type { ProductType } from "@type/global";
import { useClosableModal } from "@components/closable-modal/closable-modal-context";

function FavouriteNameModal({
  modalVisible,
  onClose,
  initialValue,
  product,
  wishlistId,
}: {
  initialValue?: string;
  modalVisible: boolean;
  onClose: () => void;
  wishlistId?: number;
  product?: ProductType;
}) {
  return (
    <ClosableModal isVisible={modalVisible} onRequestClose={onClose}>
      <Content initialValue={initialValue} product={product} wishlistId={wishlistId} />
    </ClosableModal>
  );
}

function Content({
  initialValue,
  product,
  wishlistId,
}: {
  initialValue?: string;
  wishlistId?: number;
  product?: ProductType;
}) {
  const newWishlist = useWishlistStore((state) => state.new);
  const updateWishlist = useWishlistStore((state) => state.update);
  const modalClose = useClosableModal();
  const [form, inputs] = useFormState(
    { name: initialValue ?? "" },
    {
      onSubmit: ({ name }) => {
        if (wishlistId) {
          updateWishlist({ name, wishlistId });
        } else {
          newWishlist({ name, product });
        }

        modalClose.onRequestClose();
      },
    },
  );
  return (
    <>
      <ModalTitle title={initialValue ? "Verander naam" : "Nieuwe lijst"} />
      <ModalPadding>
        <TextInput {...inputs.text("name", { required: true, label: "Naam" })} />
        <Spacer size="$4" />
        <Button onPress={form.submit} left={initialValue ? null : <PlusIcon size={24} color="$background" />}>
          {initialValue ? "Opslaan" : "Toevoegen"}
        </Button>
      </ModalPadding>
    </>
  );
}

export default FavouriteNameModal;
